/* eslint-disable no-undef */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */

/*
 * Replace all SVG images with inline SVG
 */

// eslint-disable-next-line import/prefer-default-export
export const replaceSvg = () => {
  // For each image with an SVG class, execute the following function.
  (function ($) {
    $("img.e-svg").each(function () {
      const $img = $(this);
      const imgID = $img.attr("id");
      const imgClass = $img.attr("class");
      const imgURL = $img.attr("src");

      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          let $svg = $(data).find("svg");

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", `${imgClass}`);
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");

          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });
  })(jQuery);
};

/**
 * Limit function execution to when it hasn't been called for a specified time
 * See {@link https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44}
 * @param {number} delay delay in milliseconds
 * @param {function} fn callback function
 */
export const debounce = (delay, fn) => {
  let timerId;

  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};

/**
 * Limit function execution to specified intervals
 * See {@link https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44}
 * @param {number} delay delay in milliseconds
 * @param {function} fn callback function
 */
export const throttle = (delay, fn) => {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return false;
    }
    lastCall = now;
    return fn(...args);
  };
};

/**
 * Strips special characters and whitespace from telephone number for use in href=tel attributes
 * @param {string} input Input phone number
 */
export const toCleanTelephone = (input) =>
  `${input}`.replace(/[^0-9+]/, "").replace(" ", "");

/**
 * Convert a url query string to a js object
 * @param {string} input full query string
 */
export const parseQueryString = (input) => {
  const arr = input.replace("?", "").split("&");
  const ret = {};
  arr.forEach((item) => {
    const components = item.split("=");
    if (components[0]) {
      [, ret[components[0]]] = components;
    }
  });

  return ret;
};

/**
 * Convert a js object to a url query string
 * @param {object} input shallow object
 */
export const toQueryString = (input) => {
  const arr = Object.entries(input);
  return `?${arr.map((item) => `${item[0]}=${item[1]}`).join("&")}`;
};

/**
 * Get the value from an API key
 * @param {array} key the value
 */
export const getValue = (key) => {
  if (Array.isArray(key) && key.length > 1) {
    return key.map((item) =>
      item.value !== undefined ? item.value : item.target_id
    );
  }
  if (key.length === 1) {
    return key[0].value !== undefined ? key[0].value : key[0].target_id;
  }
  return null;
};

// Get a Cookie
export const getCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

/**
 * Prepare api data for use in templates
 * @param {object} data raw api data
 */
export const prepareApiData = (data) => {
  const cookieMember = getCookie("Drupal.visitor.equiom_team_member");

  const arr = Object.values(data).map((item) => {
    const ret = {
      get full_name() {
        return `${this.first_name} ${this.last_name}`;
      },
    };

    Object.keys(item).forEach((key) => {
      if (key !== "recent") {
        ret[key] = getValue(item[key]);
      }
    });

    // Check cookies to see if the member is recently viewed
    if (parseInt(ret.node_id, 10) === parseInt(cookieMember, 10)) {
      ret.recent = true;
    }

    return ret;
  });

  // Move the recent contact to the start
  arr.sort((a, b) => {
    if (a.recent) return -1;
    if (b.recent) return 1;
    return 0;
  });

  return arr;
};

/**
 * Perform a shallow comparison of simple objects
 * @param {object} a first object
 * @param {object} b second object
 * @returns {boolean} true if objects are the same
 */
export const compareObjects = (a, b) => {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  for (let i = 0; i < aKeys.length; i++) {
    const elem = aKeys[i];
    if (b[elem] !== a[elem]) {
      return false;
    }
  }
  return true;
};

export class QueryObject {
  constructor(params = parseQueryString(window.location.search)) {
    this.params = params;
  }

  /**
   * Set the query string in the url
   * @param {object} object params
   * @param {function} callback callback function
   */
  set(object, callback) {
    this.refresh();
    // store current params
    const temp = { ...this.params };

    const { origin, pathname } = window.location;

    // update params
    this.params = Object.assign(this.params, object);

    // compare new params with old params
    if (!compareObjects(this.params, temp)) {
      // params have changed so set the url querystring
      window.history.pushState(
        null,
        null,
        origin + pathname + toQueryString(this.params)
      );
      callback(this.params);
    }
  }

  /**
   * Get an object from the url query string
   * @param {function} callback callback function
   */
  get(callback = () => null) {
    this.refresh();
    callback(this.params);
  }

  /**
   * Refresh the params object to match the current query string
   */
  refresh() {
    const parsedQueryString = parseQueryString(window.location.search);
    this.params = { ...parsedQueryString };
  }
}

/**
 * Add variables to a specified html template
 * @param {string} templateId the id attribute on the template element
 * @param {object} data an objects with keys matching those in the template
 */
export const renderTemplate = (templateId, data) => {
  const templateString = document.getElementById(templateId).innerHTML;
  const regex = /%%([a-z_]+)%%/g;
  const vars = templateString.match(regex);
  let returnString = templateString;

  vars.forEach((item) => {
    // remove percentage signs
    const key = item.replace(regex, "$1");

    // add variables to the template string
    returnString = returnString.replace(item, data[key]);
  });

  return returnString;
};

/**
 * Option for select form element
 * @param {object} item {id: number, name: string}
 */
export const optionTemplate = (item) =>
  `<option value="${item.id}">${item.name}</option>`;

/**
 * Ease out quadratic
 * @param {number} t current time
 * @param {number} d duration
 * @param {number} a start value
 * @param {number} b end value
 */
export const easeOutQuadratic = (t, d, a, b) =>
  (b - a) * (1 - (t / d - 1) ** 2) + a;

/**
 * Ease out cubic
 * @param {number} t current time
 * @param {number} d duration
 * @param {number} a start value
 * @param {number} b end value
 */
export const easeOutCubic = (t, d, a, b) =>
  (b - a) * (1 - (1 - t / d) ** 3) + a;
